<template>
    <div class="container">
        <div class="header">
            <img class="header-img" src="https://s20.lgstatic.com/growth/activity/20220608/1654675335939.png" alt="">
            <div class="header-box">
                <div class="header-box-l">
                    <div class="header-l-item">
                        <div class="line-1">8<span>大</span></div>
                        <div class="line-2">阶段体系进阶</div>
                    </div>
                    <div class="header-l-item">
                        <div class="line-1">20<span>+</span></div>
                        <div class="line-2">大厂实战项目</div>
                    </div>
                    <div class="header-l-item">
                        <div class="line-1">100<span>+</span></div>
                        <div class="line-2">技术解决方案</div>
                    </div>
                    <div class="header-l-item">
                        <div class="line-1">3<span>次</span></div>
                        <div class="line-2">专属大厂内推</div>
                    </div>
                    <div class="header-l-item">
                        <div class="line-1">1v1</div>
                        <div class="line-2">大厂专家辅导</div>
                    </div>
                    <div class="header-l-item">
                        <div class="line-1 fs30">永久</div>
                        <div class="line-2">课程视频有效</div>
                    </div>
                </div>
                <img class="header-btn"  @click="JumpFn" src="https://s20.lgstatic.com/growth/activity/20220608/1654676776858.png" />
            </div>
        </div>
        <div class="ceiling-view" v-if="ceilingType" :class="{'ceiling-fixed':ceilingType}">
            <div class="ceiling-tab">
                <div class="tab-item"
                    v-for="(item, index) in tabList" :key="index"
                    :class="{'active-tab': activeTab === index}"
                    @click="changeTab(item,index)"
                >
                    <span>{{item.stage}}</span>
                    <div v-if="activeTab === index" class="bor" />
                </div>
            </div>
        </div>
        <div class="box box-1">
            <div class="box-inner">
                <div class="box1-title">在前端进阶路上，你是否面临这些困境？</div>
                <div class="box1-items">
                    <div class="box1-item">
                        <div class="box1-item-l">
                            <div class="num">01</div>
                            <div class="box1-l-title">技术基础薄弱</div>
                        </div>
                        <div class="box1-item-r">
                            <div>只懂应用，不懂底层原理</div>
                            <div>遇到复杂问题无解法</div>
                        </div>
                    </div>
                    <div class="box1-item">
                        <div class="box1-item-l">
                            <div class="num">02</div>
                            <div class="box1-l-title">项目经验单一</div>
                        </div>
                        <div class="box1-item-r">
                            <div>长期机械重复</div>
                            <div>缺乏大型项目实战经验</div>
                        </div>
                    </div>
                    <div class="box1-item">
                        <div class="box1-item-l">
                            <div class="num">03</div>
                            <div class="box1-l-title">能力提升困难</div>
                        </div>
                        <div class="box1-item-r">
                            <div>前端技术更迭频繁</div>
                            <div>对主流技术栈不了解</div>
                            <div>缺乏体系化学习，短期难提高</div>
                        </div>
                    </div>
                    <div class="box1-item">
                        <div class="box1-item-l">
                            <div class="num">04</div>
                            <div class="box1-l-title">进大厂无通道</div>
                        </div>
                        <div class="box1-item-r">
                            <div>现有的能力和经验不足以受到大厂青睐</div>
                        </div>
                    </div>
                </div>
                <div class="box1-btn"  @click="JumpFn">你需要一次系统、高效、全面的提升</div>
            </div>
        </div>
        <div class="box box-2" id="section_0">
            <div class="box-inner">
                <div class="box2-title">拉勾带你系统重构前端技术栈</div>
                <div class="box2-sub-title">阶梯式课程体系，直通阿里 P7 级别</div>
                <div class="box2-content">
                    <div class="box2-content-item box2-content-item-1">
                        <div class="txt1">P5</div>
                        <div class="txt2">高级前端工程师</div>
                        <div class="txt3-box txt3-box-1">
                            <div>· 完成前端项目开发</div>
                            <div>· 独立完成需求解决方案</div>
                            <div>· 组件或类库的编写</div>
                        </div>
                    </div>
                    <div class="box2-content-item box2-content-item-2">
                        <div class="txt1">P6</div>
                        <div class="txt2">资深前端工程师</div>
                        <div class="txt3-box txt3-box-2">
                            <div>· 提供前端解决方案</div>
                            <div>· 负责前端代码审核和规范制定</div>
                            <div>· 保障项目进度和质量</div>
                        </div>
                    </div>
                    <div class="box2-content-item box2-content-item-3">
                        <div class="txt1">P7</div>
                        <div class="txt2">前端技术专家</div>
                        <div class="txt3-box txt3-box-3">
                            <div>· 提供技术解决方案</div>
                            <div>· 设计前端架构和组件开发</div>
                            <div>· 技术专利的发掘和专利申请的初步审核</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box box-3">
            <div  class="box-inner">
                <div class="section-main">
                    <div class="box3-sub-title">8大阶段打造你的前端核心竞争力</div>
                    <div class="main">
                        <div class="_tb">
                            <el-tabs v-model="activeName" @tab-click="changeTab">
                                <el-tab-pane class="main-tab" v-for="(item, index) in (stageList || [])" :key="index" :label="item.stage" :name="index">
                                    <div class="region">
                                        <div class="m-title"><div class="tx">{{item.title}}</div> <div class="btn" @click="seeDetail(item)"></div></div>
                                        <div class="m-icon"></div>
                                        <div class="m-txt">
                                            <div class="m-left">
                                                <div class="l-title">学习目标</div>
                                                <div class="bor"></div>
                                                <div class="item" v-for="(v, i) in item.phaseTargetList" :key="i" >{{v}}</div>
                                            </div>
                                            <div class="m-right">
                                                <div class="l-title">关键技术点</div>
                                                <div class="bor"></div>
                                                <div class="item" v-for="(v, i) in item.skillsList" :key="i" >{{v}}</div>
                                            </div>
                                        </div>
                                    </div>

                                </el-tab-pane>
                            </el-tabs>
                            <button class="stage-more" @click="JumpFn('领取完整课程安排')">
                                <img :src="imgObj.btn1">
                            </button>
                            <div class="tips-tab">
                                * 具体课程内容以实际课程安排和进度为准
                            </div>
                        </div>

                        <div class="modal" v-if="showModal">
                            <img @click="close" class="close" src="https://s21.lgstatic.com/growth/activity/20210412/1618215171460.png">
                            <div v-for="(item, index) in showData.details" :key="index">
                                <div class="modal-title">
                                    {{item.t}}
                                </div>
                                <div class="modal-desc" v-for="(i, is) in item.desc" :key="is">
                                    {{i}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box box-4" id="section_1">
            <div class="box-inner">
                <div class="box4-title">20+一线大厂实战项目 解决业务真问题</div>
                <div class="box4-cards">
                    <div class="box4-card">
                        <div class="card-head">【电商】拉勾心选</div>
                        <div class="card-content">
                            <div class="card-label">项目介绍</div>
                            <div class="label-txt">《拉勾心选》属于 B2C 电商平台，类似于京东、天猫，提供完整的在线购物流程。<br>
                            项目整体分为三大板块：基于 Node.js 后端服务开发、基于 React 的管理系统开发、基于 Node.js 的网站前台开发</div>
                            <div class="card-label">核心功能模块</div>
                            <div class="card-label-title">管理平台：</div>
                            <div class="card-sub-txt">管理员登陆、用户鉴权/权限控制<br>
                                权限管理：角色、权限、资源、菜单<br>
                                商品管理：新建、维护、上架、活动<br>
                                订单管理：订单查询、订单状态维护<br>
                                广告管理：广告位管理、广告维护
                            </div>
                            <img class="card-img" src="https://s20.lgstatic.com/growth/activity/20220609/1654747769801.png" alt="">
                        </div>
                    </div>
                    <div class="box4-card">
                        <div class="card-head">【在线教育】 拉勾教育</div>
                        <div class="card-content">
                            <div class="card-label">项目介绍</div>
                            <div class="label-txt">《拉勾教育》是一个在线教育平台，依托这个平台，用户可以实现在线选课，购买课程，在线学习。<br>
                            项目整体基于 Vue.js 框架及周边生态库，学习完该项目即可完整掌握 Vue.js 核心技术架构体系以及在企业项目中的实际应用。</div>
                            <div class="card-label">核心功能模块</div>
                            <div class="card-label-title">管理端：</div>
                            <div class="card-sub-txt">
                                管理员登陆、用户鉴权/权限控制<br>
                                权限管理：角色、权限、资源、菜单<br>
                                商品管理：新建、维护、上架、活动<br>
                                内容管理：章节知识点维护、音频库上传、<br>封面图片生成
                            </div>
                            <img class="card-img card-img2" src="https://s21.lgstatic.com/growth/activity/20220609/1654748007440.png" alt="">
                        </div>
                    </div>
                </div>
                <img class="box4-btn"  @click="JumpFn('获取更多项目资料')" src="https://s21.lgstatic.com/growth/activity/20220609/1654748345252.png" alt="">
            </div>
        </div>
        <div class="box box-5" id="section_2">
            <div class="box-inner">
                <div class="box5-title">贯穿全程的学习就业服务</div>
                <div class="box5-sub-title">日日精进，学业就业更轻松</div>
                <div class="box5-cards">
                    <div class="box5-card">
                        <div class="box5-card-title">问题答疑</div>
                        <div class="box5-card-content">
                            <div class="box5-card-txt">① 及时响应，专业解答</div>
                            <div class="box5-card-txt">② 答题板模式，问题汇总复习更方便</div>
                        </div>
                    </div>
                    <div class="box5-card">
                        <div class="box5-card-title">专题直播</div>
                        <div class="box5-card-content">
                            <div class="box5-card-txt">① 每周至少一场直播，解决学习疑惑</div>
                            <div class="box5-card-txt">② 邀请大厂专家不定期经验分享</div>
                        </div>
                    </div>
                    <div class="box5-card">
                        <div class="box5-card-title">独家资料</div>
                        <div class="box5-card-content">
                            <div class="box5-card-txt">① 提供独家学习资料，深入回顾和扩展</div>
                        </div>
                    </div>
                    <div class="box5-card">
                        <div class="box5-card-title">源码开放</div>
                        <div class="box5-card-content">
                            <div class="box5-card-txt">① 提供学习中所有涉及的项目，并长期迭代维护</div>
                        </div>
                    </div>
                    <div class="box5-card">
                        <div class="box5-card-title">大厂内推*</div>
                        <div class="box5-card-content">
                            <div class="box5-card-txt">① 享受3次大厂内推</div>
                            <div class="box5-card-txt">② 简历直达企业业务Leader，更高效</div>
                        </div>
                    </div>
                    <div class="box5-card more">
                        <div class="box5-card-title">1v1大厂专家辅导</div>
                        <div class="box5-card-content">
                            <div class="box5-card-txt">① 大厂技术专家 1v1 就业指导形式任你选，模拟面试/职业规划/面试辅导...</div>
                        </div>
                    </div>
                </div>
                <div class="box5-sub-title box5-sub-title2">解锁闯关式学习，扎实你的每一步</div>
                <div class="box5-steps">
                    <div class="box5-step step1">
                        <div class="step-title">Step 1</div>
                        <div class="step-txt">完成模块学习进度80%解锁下一关</div>
                    </div>
                    <div class="box5-step step2">
                        <div class="step-title">Step 2</div>
                        <div class="step-txt">阶段性测评，巩固学习成果</div>
                    </div>
                    <div class="box5-step step3">
                        <div class="step-title">Step 3</div>
                        <div class="step-txt">结课毕业收获大厂内推</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="box box-6" id="section_3">
            <div class="box-inner">
                <div class="box6-title">现在加入「大厂私教计划」升级你的就业服务</div>
                <div class="box6-sub-title">【师资升级】大厂在职 P7 +做你的私教</div>
                <div class="box6-content">
                    <div class="box6-btn box6-l-btn">私教来自哪里？</div>
                    <div class="box6-btn box6-r-btn">私教实力如何？</div>
                    <div class="box6-l-content">
                        <img src="https://s20.lgstatic.com/growth/activity/20220609/1654760257386.png">
                        <img src="https://s20.lgstatic.com/growth/activity/20220609/1654760266205.png">
                        <img src="https://s20.lgstatic.com/growth/activity/20220609/1654760274292.png">
                        <img src="https://s21.lgstatic.com/growth/activity/20220609/1654760283700.png">
                        <img src="https://s20.lgstatic.com/growth/activity/20220609/1654760296584.png">
                        <img src="https://s20.lgstatic.com/growth/activity/20220609/1654760310242.png">
                        <img src="https://s20.lgstatic.com/growth/activity/20220609/1654760322722.png">
                        <img src="https://s20.lgstatic.com/growth/activity/20220609/1654760330195.png">
                    </div>
                    <div class="box6-r-content">
                        <div class="box6-r-item">
                            <div class="r-item-title">资历深</div>
                            <div class="r-item-con">
                                <div class="cont-txt">平均8年+从业经验</div>
                                <div class="cont-txt">不乏10年+的资深行业风向标</div>
                            </div>
                        </div>
                        <div class="box6-r-item">
                            <div class="r-item-title">背景好</div>
                            <div class="r-item-con">
                                <div class="cont-txt">均为大厂在职从业背景</div>
                                <div class="cont-txt">对标阿里 P7+ 专家级能力</div>
                            </div>
                        </div>
                        <div class="box6-r-item">
                            <div class="r-item-title left20">经验丰富</div>
                            <div class="r-item-con">
                                <div class="cont-txt">各行业爆款项目成功经验，支撑百亿级年收入</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box6-sub-title box6-sub-title2">【学习计划升级】私教量身定制进阶课程</div>
                <div class="box6-steps">
                    <div class="box6-step step1">
                        <div class="step-title">学前准备</div>
                        <div class="step-txt">私教1v1能力评估，制定专属学习计划</div>
                    </div>
                    <div class="box6-step step2">
                        <div class="step-title">Step 1</div>
                        <div class="step-txt">根据摸底结果，精准提升薄弱技术</div>
                    </div>
                    <div class="box6-step step3">
                        <div class="step-title">Step 2</div>
                        <div class="step-txt">讲解高阶岗位技术点，提升技术视野</div>
                    </div>
                    <div class="box6-step step4">
                        <div class="step-title">Step 3</div>
                        <div class="step-txt">还原业务场景，培养大厂式问题解决思路</div>
                    </div>
                    <div class="box6-step step5">
                        <div class="step-title">Step 4</div>
                        <div class="step-txt">对学员自身项目场景做优化落地实践</div>
                    </div>
                    <div class="box6-step step6">
                        <div class="step-title">Step 5</div>
                        <div class="step-txt">规划学员求职路径，进行大厂面试辅导</div>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- <div class="box box-7">
            <div class="box-inner">
                <div class="box7-sub-title">【Offer 升级】名企优先入职，无Offer保赔付*</div>
                <div class="box7-content">
                    <img src="https://s20.lgstatic.com/growth/activity/20220610/1654828177041.png" alt="">
                    <img src="https://s20.lgstatic.com/growth/activity/20220610/1654828186587.png" alt="">
                    <img src="https://s21.lgstatic.com/growth/activity/20220610/1654828194018.png" alt="">
                    <img src="https://s21.lgstatic.com/growth/activity/20220610/1654828202339.png" alt="">
                    <img src="https://s21.lgstatic.com/growth/activity/20220610/1654828210502.png" alt="">
                    <img src="https://s21.lgstatic.com/growth/activity/20220610/1654828218637.png" alt="">
                    <img src="https://s21.lgstatic.com/growth/activity/20220610/1654828227618.png" alt="">
                    <img src="https://s20.lgstatic.com/growth/activity/20220610/1654828235875.png" alt="">
                    <img src="https://s21.lgstatic.com/growth/activity/20220610/1654828244706.png" alt="">
                    <img src="https://s21.lgstatic.com/growth/activity/20220610/1654828253362.png" alt="">
                    <img src="https://s20.lgstatic.com/growth/activity/20220610/1654828263358.png" alt="">
                    <img src="https://s21.lgstatic.com/growth/activity/20220610/1654828271100.png" alt="">
                    <img src="https://s21.lgstatic.com/growth/activity/20220610/1654828279715.png" alt="">
                    <img src="https://s21.lgstatic.com/growth/activity/20220610/1654828288312.png" alt="">
                    <img src="https://s21.lgstatic.com/growth/activity/20220610/1654828297307.png" alt="">
                    <img src="https://s21.lgstatic.com/growth/activity/20220610/1654828308301.png" alt="">
                </div>
                <div class="box7-btn"  @click="JumpFn">了解大厂私教计划</div>
            </div>
        </div> -->
        <!-- <div class="box box-8" id="section_4">
            <div class="box-inner">
                <div class="box8-title">学员好评力荐这门课</div>
                <div class="box8-sub-title">学长学姐说</div>
                <div class="box8-pops">
                    <div class="box8-pop">内容实用</div>
                    <div class="box8-pop">内容体系全面</div>
                    <div class="box8-pop">老师认真负责</div>
                    <div class="box8-pop">学习氛围好</div>
                </div>
                <div class="box8-pops box8-pops2">
                    <div class="box8-pop">技术视野拓展</div>
                    <div class="box8-pop">对面试帮助很大</div>
                    <div class="box8-pop">课程时时迭代与时俱进</div>
                </div>
                <div class="swiper-container sw1-wrap">
                    <div class="swiper-wrapper">
                        <div v-for="item in swiperList1" :key="item" class="swiper-slide">
                            <img :src="item" >
                        </div>
                    </div>
                    <div class="swiper-pagination sw1-pagination" />
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                </div>
            </div>
        </div>
        <div class="box box-9">
            <div class="box-inner">
                <div class="box9-sub-title">更多好评反馈</div>
                <div class="swiper-container sw2-wrap">
                    <div class="left-mask"></div>
                    <div class="right-mask"></div>
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(swiper, index) in swiperList2" :key="index">
                            <img :src="swiper" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="box box-10">
            <div class="box-inner">
                <div class="box10-title">求职进大厂 就选拉勾平台</div>
                <div class="box10-labels">
                    <div class="box10-label">
                        <div class="babel-line label-1">
                            <img src="https://s21.lgstatic.com/growth/activity/20220610/1654832994574.png" alt="">
                            <div>互联网公司入驻拉勾</div>
                        </div>
                        <div class="label-tips">包括阿里巴巴、字节跳动、腾讯等大厂</div>
                    </div>
                    <div class="box10-label">
                        <div class="babel-line label-2">
                            <img src="https://s21.lgstatic.com/growth/activity/20220610/1654833489115.png" alt="">
                            <div>企业 使用拉勾招聘人才</div>
                        </div>
                    </div>
                    <div class="box10-label">
                        <div class="babel-line label-3">
                            <img src="https://s21.lgstatic.com/growth/activity/20220610/1654833570498.png" alt="">
                            <div>互联网人 使用拉勾找工作</div>
                        </div>
                    </div>
                </div>
                <div class="box10-tips">*“内推”、“直推”、“就业推荐”等服务需要满足一定考核标准，详见《服务协议》</div>
            </div>
        </div>
        <div class="box box-fixed">
            <div class="box-inner">
                <div class="box10-content">
                    <div class="box10-left">
                        <img src="https://s21.lgstatic.com/growth/activity/20220610/1654846808855.png" alt="">
                        咨询课程顾问 抢大额优惠券
                    </div>
                    <div class="box10-right" @click="JumpFn('名额有限立即抢占')">好课速享 马上抢占</div>
                </div>
            </div>
        </div>
        <!-- <button class="footer" @click="JumpFn">
            <img class="img" :src="imgObj.footer">
            <div class="iconBox" v-if="activity.isShow">
                <img class="icon" :src="activity.PCicon">
            </div>
        </button> -->
    </div>
</template>

<script>
import { handleJumpUrl } from '../../../uitl/getParam.js';
import activity from '../../../common/activity';
import List from './data.js';
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
export default {
    name: 'SignIn',
    data() {
        return {
            activity,
            List,
            imgObj:{},
            imgList:[],
            imgList1:[],
            tabList:[],
            stageList:[],
            swiperList:[],
            swiperList1:[],
            ceilingType:false,//吸顶tab
            showData:{},
            showModal:false,
            activeTab:0,
            swiperList2: [
                "https://s21.lgstatic.com/growth/activity/20220607/1654586773867.png",
                "https://s21.lgstatic.com/growth/activity/20220607/1654586782592.png",
                "https://s21.lgstatic.com/growth/activity/20220607/1654586790469.png",
                "https://s21.lgstatic.com/growth/activity/20220607/1654586799039.png",
                "https://s20.lgstatic.com/growth/activity/20220607/1654586808764.png",
                "https://s21.lgstatic.com/growth/activity/20220607/1654586819734.png",
                "https://s20.lgstatic.com/growth/activity/20220607/1654586827220.png",
                "https://s21.lgstatic.com/growth/activity/20220607/1654586835960.png",
            ],
            addressIdsMap: {
                "课程体系": "a1tu4",
                "实战项目": "b1tu5",
                "就业服务": "c1tu6",
                "用户评价": "d1tu7",
                "领取完整课程安排": "e1tu8",
                "获取更多项目资料": "f1tu9",
                "名额有限立即抢占": "g1tua"
            }
        };
    },
    created() {
        let dataList = this.List.data;
        this.imgObj = dataList.pc.imgObj
        this.imgList = dataList.pc.imgList
        this.imgList1 = dataList.pc.imgList1
        this.swiperList = dataList.pc.swiperList
        this.swiperList1 = dataList.pc.swiperList1
        this.tabList = dataList.tabList
        this.stageList = dataList.stageList

        setTimeout(()=>{
            // this.eduPlatTrack('WebView', { page_id: '1pxi'});
            this.platTrack('pcpv', {
                page_id: 'h1typ',
            })
            // this.swiperInit()
            this.renderSwiper()
        },500)
        window.addEventListener('scroll', this.scrollTopFn)
    },
    destroyed () {
        window.removeEventListener('scroll', this.scrollTopFn)
    },
    methods: {
        changeTab(item,index) {
            console.log(item, index)
            this.activeTab = index
            let arr = [
                "#section_0",
                "#section_1",
                "#section_2",
                // "#section_3",
                // "#section_4",
            ]
            console.log(this.$el.querySelector(arr[index]))
            this.$el.querySelector(arr[index]).scrollIntoView(true);
            let scroll = document.documentElement.scrollTop || document.body.scrollTop;
            document.documentElement.scrollTop = scroll - 50
            document.body.scrollTop = scroll - 50
            // this.eduPlatTrack('WebButtonClick', {
            //     'page_id': '1pxi',
            //     'button_name': item.stage
            // });
            this.platTrackClickFn(item.stage);
        },
        scrollTopFn() {
            let scroll = document.documentElement.scrollTop || document.body.scrollTop;
            console.log(scroll)
            this.ceilingType = scroll > 520 ? true : false; //吸顶tab
            let arr = [
                "section_0",
                "section_1",
                "section_2",
                // "section_3",
                // "section_4",
            ]
            arr.forEach((item,index) =>{
                if(document.getElementById(item).getBoundingClientRect().top < 200) {
                    this.activeTab = index
                }
            })
        },
        JumpFn(str) {
            // this.eduPlatTrack('WebButtonClick', {
            //     'page_id': '1pxi',
            //     'button_name': '领取成长路线图'
            // });
            str && this.platTrackClickFn(str);
            setTimeout(() => {
                window.location.href = 'https://t.lagou.com/DR99RXRcs=6B1'; 
            }, 200)
        },
        seeDetail(val) {
            this.showModal = true;
            this.showData = val
        },
        close() {
            this.showModal = false;
        },
        changeTabs(val) {
            this.showModal = false
        },
        swiperInit() {
            let option = {
                direction: 'horizontal',
                loop: true,
                speed: 500,
                autoplayDisableOnInteraction: false,
                autoplay: 3000,
                pagination: '.sw-pagination',
                paginationClickable: true,
                // prevButton: '.swiper-button-prev',
                // nextButton: '.swiper-button-next',
                spaceBetween: 30
            };
            this.$nextTick(() => {
                const swiper2 = new Swiper('.sw-wrap', option);
            });
        },
        renderSwiper() {
            setTimeout(() => {
                let modify = 0;
                let translate = 0;
                let scale = 0;
                const swiper = new Swiper('.sw1-wrap', {
                    autoplay: 3000,
                    loop: true,
                    slidesPerView: 'auto',
                    loopedSlides: 4,
                    pagination: '.sw1-pagination',
                    paginationClickable: true,
                    watchSlidesProgress: true,
                    prevButton: '.swiper-button-prev',
                    nextButton: '.swiper-button-next',
                    centeredSlides: true,
                    onSetTransition: (swiper, transition) => {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            let slide = swiper.slides.eq(i);
                            slide.transition(transition);
                        }
                    },
                });

                swiper.on('progress', () => {
                    for (let i = 0; i < swiper.slides.length; i++) {
                        let slide = swiper.slides.eq(i);
                        let slideProgress = swiper.slides[i].progress;
                        modify = 1;
                        if (Math.abs(slideProgress) > 1) {
                            modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                        }
                        translate = slideProgress * modify * 500 + 'PX';
                        scale = 1 - Math.abs(slideProgress) / 5;
                        let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                        slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                        slide.css('zIndex', zIndex);
                    }
                });
            }, 500);
            setTimeout(() => {
                var swiper = new Swiper('.sw2-wrap', {
                    autoplay: 3000,
                    loop: true,
                    slidesPerView: 'auto',
                    paginationClickable: true,
                    spaceBetween: 20,
                    freeMode: true
                });
            }, 500)
        },
        platTrackClickFn(name) {
            this.platTrack('pcclick', {
                page_id: 'h1typ',
                address_id: this.addressIdsMap[name]
            })
        }
    }
};
</script>

<style lang='less' scoped>
.container {
    width: 100%;
    min-width: 1200PX;
    background: #F2F2FA;
    padding-bottom: 118PX;
}
.header {
    position: relative;
    width: 100%;
    height: 597PX;
    background: linear-gradient(130deg, #A72FFF 0%, #7F41FF 100%);
    .header-img {
        display: block;
        width: 1200PX;
        height: 597PX;
        margin: 0 auto;
    }
    .header-box {
        display: flex;
        position: absolute;
        left: 50%;
        bottom: -71PX;
        width: 1200PX;
        height: 142PX;
        background-color: #fff;
        border-radius: 12PX;
        transform: translateX(-50%);
        padding: 42PX 40PX 42PX 56PX;
        box-sizing: border-box;
        .header-box-l {
            display: flex;
            width: 937PX;
            height: 58PX;
            padding-right: 50PX;
            box-sizing: border-box;
        }
        .header-btn {
            width: 168PX;
            height: 58PX;
        }
    }
    .header-l-item {
        position: relative;
        padding: 0 24PX;
        &::after {
            position: absolute;
            right: 0;
            top: 10PX;
            content: "";
            width: 1PX;
            height: 42PX;
            background-color: #D9DAE0;
        }
        &:last-child {
            &::after {
                display: none;
            }
        }
        .line-1 {
            width: 100%;
            height: 36PX;
            line-height: 36PX;
            text-align: center;
            font-size: 36PX;
            font-weight: bold;
            color: #A954FF;
            &>span {
                font-size: 20PX;
                font-weight: normal;
            }
            &.fs30 {
                font-size: 30PX;
            }
        }
        .line-2 {
            font-size: 16PX;
            color: #333;
            margin-top: 8PX;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
        }
    }
}
.box {
    width: 100%;
    .box-inner {
        position: relative;
        width: 1200PX;
        height: 100%;
        margin: 0 auto;
        overflow: hidden;
    }
    &-1 {
        height: 785PX;
        background-color: #F2F2FA;
    }
    &-2 {

        height: 769PX;
        background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
        .box-inner {
            width: 1235PX;
        }
    }
    &-3 {
        height: 682PX;
        background: linear-gradient(179deg, #A954FF 0%, #684CFF 100%);
        .box-inner {
            overflow: initial;
        }
    }
    &-4 {
        height: 960PX;
        background-color: #F2F2FA;
        .box-inner  {
            width: 1264PX;
        }
    }
    &-5 {
        height: 1025PX;
        background: linear-gradient(180deg, rgba(255, 255, 255, .4) 0%, rgba(255, 255, 255, .4) 100%);
    }
    &-6 {
        height: 1407PX;
        background-color: #F2F2FA;
    }
    &-7 {
        height: 800PX;
        background-color: rgba(255, 255, 255, .4);
    }
    &-8 {
        height: 805PX;
        background: linear-gradient(179deg, #A954FF 0%, #684CFF 100%);
    }
    &-9 {
        height: 913PX;
        background-color: #F2F2FA;
        .box-inner  {
            width: 1482PX;
        }
    }
    &-10 {
        height: 324PX;
        background: linear-gradient(179deg, #A954FF 0%, #684CFF 100%);
    }
    &-fixed {
        position: fixed;
        bottom: 0;
        left: 0;
        height: 118PX;
        line-height: 118PX;
        background-color: #fff;
        z-index: 999;
    }
}
.box1-title {
    text-align: center;
    font-size: 40PX;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #414878;
    line-height: 40PX;
    margin-top: 160PX;
}
.box1-items {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 50PX;
}
.box1-item {
    position: relative;
    width: 584PX;
    height: 118PX;
    background: url('https://s20.lgstatic.com/growth/activity/20220609/1654740986593.png') no-repeat center;
    background-size: 584PX 118PX;
    margin-bottom: 50PX;
    .box1-item-l {
        position: absolute;
        left: 0;
        top: 0;
        width: 146PX;
        height: 109PX;
        .num {
            width: 36PX;
            height: 36PX;
            background-color: #fff;
            line-height: 36PX;
            text-align: center;
            color: #854FFF;
            font-size: 18PX;
            border-radius: 50%;
            margin: 18PX auto 15PX;
        }
        .box1-l-title {
            height: 20PX;
            line-height: 20PX;
            font-size: 20PX;
            color: #FFFFFF;
            text-align: center;
        }
    }
    .box1-item-r {
        position: absolute;
        top: 9PX;
        right: 0;
        width: 438PX;
        height: 109PX;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        flex-wrap: wrap;
        padding: 0 18PX 0 61PX;
        box-sizing: border-box;
        &>div {
            position: relative;
            width: 100%;
            color: rgba(88, 94, 139, .65);
            font-size: 16PX;
            line-height: 20PX;
            &::before {
                position: absolute;
                left: -16PX;
                top: 7PX;
                content: "";
                width: 6PX;
                height: 6PX;
                background-color: rgba(88, 94, 139, .65);
                border-radius: 50%;
            }
        }
    }
}
.box1-btn {
    width: 684PX;
    height: 104PX;
    line-height: 104PX;
    border-radius: 52PX;
    background: linear-gradient(141deg, #A954FF 0%, #684CFF 100%);
    color: #fff;
    font-size: 30PX;
    font-weight: bold;
    text-align: center;
    margin: 10PX auto 0;
}
.ceiling-view {
        width: 100%;
        height: 66PX;
        margin: 0PX auto 40PX;
        background-color: #fff;
        .ceiling-tab {
            width: 1100PX;
            margin: 0 auto;
            height: 66PX;
            background-color: #fff;
            border-radius: 2PX;
            box-shadow: 0PX 6PX 8PX 0PX rgba(214, 209, 250, 0.08);
            display: flex;
            align-items: center;
            cursor: pointer;
            // transform: scale(.7);
            .tab-item {
                position: relative;
                flex: 1;
                text-align: center;
                font-size: 20PX;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #32355C;
                height: 100%;
                line-height: 66PX;
                box-sizing: border-box;
                .bor {
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translate(-50%);
                    width: 168PX;
                    height: 3PX;
                    border-radius: 1PX;
                    background: linear-gradient(141deg, #A954FF 0%, #684CFF 100%);
                }
            }
            .active-tab {
                box-sizing: border-box;
                padding-left: 40PX;
                &::before{
                    content: '';
                    width: 24PX;
                    height: 24PX;
                    background: url('https://s21.lgstatic.com/growth/activity/20210913/1631520740389.png') no-repeat center;
                    background-size: 100% 100%;
                    position: absolute;
                    left: 62PX;
                    top:50%;
                    transform: translateY(-50%);
                    transition-duration: 0.3s;
                }
            }

        }
        @media screen and (max-width:1900px){
            .ceiling-tab {
                width: 940PX;
                .tab-item {
                    .bor {
                        width: 148PX;
                    }
                }
                .active-tab {
                    padding-left: 40PX;
                    &::before{
                        left: 44PX;
                    }
                }
            }
        }
        @media screen and (max-width:1500px){
            .ceiling-tab {
                width: 790PX;
                .tab-item {
                    .bor {
                        width: 140PX;
                    }
                }
                .active-tab {
                    padding-left: 30PX;
                    &::before{
                        left: 26PX;
                    }
                }
            }
        }

}
.ceiling-fixed {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translate(-50%);
    z-index: 30;
}
.box2-title {
    text-align: center;
    font-size: 40PX;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #414878;
    line-height: 40PX;
    margin-top: 80PX;
}
.box2-sub-title {
    position: relative;
    width: 389PX;
    height: 36PX;
    font-size: 24PX;
    font-family: AppleSystemUIFont;
    color: #414878;
    line-height: 36PX;
    margin-top: 12PX;
    text-align: center;
    margin: 12PX auto 0;
    &::before {
        content: '';
        position: absolute;
        left: -79PX;
        top: 13PX;
        width: 59PX;
        height: 9PX;
        background: url('https://s20.lgstatic.com/growth/activity/20220609/1654743608150.png') no-repeat center;
        background-size: 59PX 9PX;
        z-index: 9;
    }
    &::after {
        content: '';
        position: absolute;
        right: -79PX;
        top: 13PX;
        width: 59PX;
        height: 9PX;
        background: url('https://s20.lgstatic.com/growth/activity/20220609/1654743626450.png') no-repeat center;
        background-size: 59PX 9PX;
        z-index: 9;
    }
}
.box2-content {
    position: relative;
    width: 1235PX;
    height: 392PX;
    background: url('https://s20.lgstatic.com/growth/activity/20220609/1654743511477.png') no-repeat center;
    background-size: 1235PX 392PX;
    margin-top: 48PX;
    .box2-content-item {
        position: absolute;
        bottom: 0;
        &-1 {
            left: 0;
            width: 411PX;
            height: 297PX;
        }
        &-2 {
            left: 411PX;
            width: 418PX;
            height: 339PX;
        }
        &-3 {
            right: 0;
            width: 407PX;
            height: 391PX;
        }
        .txt1 {
            height: 56PX;
            font-size: 56PX;
            font-family: AppleSystemUIFont;
            color: #FFFFFF;
            line-height: 56PX;
            padding-left: 29PX;
            box-sizing: border-box;
            margin-top: 30PX;
        }
        .txt2 {
            height: 34PX;
            font-size: 28PX;
            font-family: AppleSystemUIFont;
            color: #FFFFFF;
            line-height: 34PX;
            padding-left: 29PX;
            box-sizing: border-box;
            margin-top: 12PX;
        }
        .txt3-box {
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: 18PX 0 0 8PX;
            padding-left: 14PX;
            box-sizing: border-box;
            &-1 {
                width: 393PX;
                height: 137PX;
            }
            &-2 {
                width: 407PX;
                height: 168PX;
                margin-top: 31PX;
                &>div {
                    margin-bottom: 16PX;
                }
            }
            &-3 {
                width: 387PX;
                height: 218PX;
                &>div {
                    margin-bottom: 16PX;
                }
            }
            &>div {
                width: 100%;
                height: 30PX;
                font-size: 22PX;
                font-family: AppleSystemUIFont;
                color: #FFFFFF;
                line-height: 30PX;
            }
        }

    }
}
.section-main {
        width: 100%;
        min-width: 1200PX;
        padding-top: 1PX;
        position: relative;
        margin-bottom: 100PX;
        .tab-bg {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            width: 100%;
            height: 740PX;
            background: linear-gradient(179deg, #A954FF 0%, #684CFF 100%);
            overflow: hidden;
            img {
                width: 458PX;
                display: block;
                margin: 135PX auto 0;
            }
        }
        .main {
            position: relative;
            width: 1060PX;
            margin: 48PX auto 0;
            padding-top: 1PX;
            z-index: 2;
            .tips-tab {
                font-size: 14PX;
                color: #666;
                position: absolute;
                bottom: 40PX;
                right: 60PX;
            }
            .tab-title-img {
                position: absolute;
                top: 0;
                left: 0;
                display: block;
                width:100%;
            }
            ._tb {
                position: relative;
                margin: 0 auto;
                width: 1000PX;
                background-color: #fff;
                box-sizing: border-box;
                padding: 30PX 40PX 100PX;
                border-radius: 22px;
                /deep/ .el-tabs {
                    width: 100%;
                    .el-tabs__header, .el-tabs__nav-wrap, .el-tabs__nav-scroll, .el-tabs__nav {
                        height: 47PX;
                    }
                    .el-tabs__item {
                        line-height: 47PX;
                        text-align: center;
                        width: 150PX;
                        height: 47PX;
                        padding: 0;
                        font-size: 18PX;
                        font-family: SourceHanSansSC-Bold, SourceHanSansSC;
                        font-weight: 400;
                        color: rgba(50, 50, 50, 1);
                        margin: 0 17PX;
                    }
                    .el-tabs__nav-wrap::after{
                        background-color: transparent;
                    }
                    .el-tabs__active-bar {
                        background-color: transparent;
                    }
                    .el-tabs__item.is-active {
                        border-radius: 50PX;
                        padding: 0;
                        background: linear-gradient(141deg, #A954FF 0%, #684CFF 100%);
                        color: #fff;
                    }

                    .el-tabs__nav-prev {
                        top: 50%;
                        font-weight: 500;
                        font-size: 34PX;
                        transform: translateY(-50%);
                    }
                    .el-tabs__nav-next {
                        top: 50%;
                        font-weight: 500;
                        font-size: 34PX;
                        transform: translateY(-50%);
                    }
                }
                .region {
                    width: 100%;
                    padding-top: 20PX;
                    .m-title {
                        width: 100%;
                        height: 30PX;
                        position: relative;
                        font-size: 24PX;
                        color: #303032;
                        text-align: center;
                        font-family: Helvetica;
                        font-weight: normal;
                        .tx {
                            position: absolute;
                            top: 0PX;
                            left: 50%;
                            transform: translate(-50%);
                        }
                        .btn {
                            float: right;
                            width: 90PX;
                            height: 30PX;
                            background: url('https://s21.lgstatic.com/growth/activity/20210325/1616656811847.png') no-repeat;
                            background-size: 100% 100%;
                            margin-right: 40PX;
                        }
                    }
                    .m-icon {
                        margin: 8PX auto;
                        width: 688PX;
                        height: 2PX;
                        background: url('https://s21.lgstatic.com/growth/activity/20210402/1617345169076.png') no-repeat center;
                        background-size: 100% 100%;
                    }
                    .m-txt {
                        width: 100%;
                        display: flex;
                        margin-top: 30PX;
                        .m-left {
                            flex: 1;
                            box-sizing: border-box;
                            padding: 10PX 30PX;
                        }
                        .m-right {
                            width: 312PX;
                            box-sizing: border-box;
                            padding: 10PX 10PX;
                        }
                        .l-title {
                            font-size: 16PX;
                            font-family: Helvetica;
                            color: #36363C;
                        }
                        .bor {
                            width: 312PX;
                            height: 1PX;
                            margin: 16PX 0 20PX;
                            background-color: rgba(132, 132, 135, .4);
                        }
                        .item {
                            position: relative;
                            font-size: 14PX;
                            font-family: Helvetica;
                            color: #49494B;
                            padding-left: 15PX;
                            margin: 14PX 0;
                            &::after {
                                position: absolute;
                                content: '';
                                left: 0PX;
                                top: 8PX;
                                width: 4PX;
                                height: 4PX;
                                border-radius: 50%;
                                background: #6469A7;
                            }
                        }
                    }
                }
            }
            .stage-more {
                position: absolute;
                bottom: -30PX;
                left: 50%;
                transform: translate(-50%);
                width: 294PX;
                background-color:transparent;
                border: none;
                z-index: 9;
                img {
                    width: 100%;
                    display: block;
                }
            }
            .modal {
                position: absolute;
                top: 156PX;
                left: 50%;
                transform: translate(-50%);
                width: 800PX;
                border-radius: 16PX;
                background-color: #fefefe;
                z-index: 999;
                border: 2PX solid #6469A7;
                box-sizing: border-box;
                padding: 20PX 50PX 40PX;
                .close {
                    position: absolute;
                    right: 14PX;
                    top: 14PX;
                    width: 40PX;
                    height: 40PX;
                }
                .modal-title {
                    font-size: 20PX;
                    padding:35PX 0 10PX;
                    color: #6469A7;
                }
                .modal-desc {
                    font-size: 14PX;
                    color: #6469A7;
                    padding-left: 18PX;
                }
            }
        }
}
.box3-sub-title {
    position: relative;
    width: 389PX;
    height: 36PX;
    font-size: 24PX;
    font-family: AppleSystemUIFont;
    color: #fff;
    line-height: 36PX;
    text-align: center;
    margin: 90PX auto 0;
    &2 {
        width: 434PX;
        margin-top: 0;
    }
    &::before {
        content: '';
        position: absolute;
        left: -79PX;
        top: 13PX;
        width: 59PX;
        height: 9PX;
        background: url('https://s21.lgstatic.com/growth/activity/20220610/1654828795175.png') no-repeat center;
        background-size: 59PX 9PX;
        z-index: 9;
    }
    &::after {
        content: '';
        position: absolute;
        right: -79PX;
        top: 13PX;
        width: 59PX;
        height: 9PX;
        background: url('https://s20.lgstatic.com/growth/activity/20220610/1654828766432.png') no-repeat center;
        background-size: 59PX 9PX;
        z-index: 9;
    }
}
.box4-title {
    text-align: center;
    font-size: 40PX;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #414878;
    line-height: 40PX;
    margin-top: 201PX;
}
.box4-cards {
    display: flex;
    margin-top: 48PX;
    justify-content: space-between;
    .box4-card {
        position: relative;
        width: 620PX;
        height: 473PX;
        background: url('https://s21.lgstatic.com/growth/activity/20220609/1654746484792.png') no-repeat center;
        background-size: 620PX 437PX;
        .card-head {
            position: absolute;
            top: 14PX;
            left: 0;
            width: 100%;
            height: 76PX;
            line-height: 76PX;
            color: #fff;
            font-size: 24PX;
            padding-left: 36PX;
            box-sizing: border-box;
        }
        .card-content {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 396PX;
            padding: 25PX 35PX 20PX 30PX;
            box-sizing: border-box;
            .card-label {
                display: inline-block;
                padding: 0 16PX;
                height: 30PX;
                line-height: 30PX;
                background: linear-gradient(192deg, rgba(99, 137, 255, .1) 0%, rgba(108, 101, 255, .1) 100%);
                border-radius: 15PX;
                font-size: 15PX;
                font-family: AppleSystemUIFont;
                color: #585E8B;
            }
            .label-txt {
                font-size: 16PX;
                font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                font-weight: 400;
                color: #585E8B;
                line-height: 20PX;
                margin-top: 13PX;
                margin-bottom: 13PX;
            }
            .card-label-title {
                height: 23PX;
                font-size: 15PX;
                font-family: AppleSystemUIFont;
                color: #585E8B;
                line-height: 20PX;
                margin-top: 14PX;
            }
            .card-sub-txt {
                font-size: 14PX;
                font-family: AppleSystemUIFont;
                color: #585E8B;
                line-height: 20PX;
            }
            .card-img {
                position: absolute;
                bottom: 38PX;
                right: 39PX;
                width: 251PX;
                height: 123PX;
                &2 {
                    width: 239PX;
                    height: 117PX;
                }
            }
        }
    }
}
.box4-btn {
    display: block;
    width: 294PX;
    height: 65PX;
    margin: 48PX auto 0;
}
.box5-title {
    text-align: center;
    font-size: 40PX;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #414878;
    line-height: 40PX;
    margin-top: 90PX;
}
.box5-sub-title {
    position: relative;
    width: 310PX;
    height: 36PX;
    font-size: 24PX;
    font-family: AppleSystemUIFont;
    color: #414878;
    line-height: 36PX;
    margin-top: 12PX;
    text-align: center;
    margin: 12PX auto 0;
    &2 {
        width: 389PX;
        margin-top: 80PX;
    }
    &::before {
        content: '';
        position: absolute;
        left: -79PX;
        top: 13PX;
        width: 59PX;
        height: 9PX;
        background: url('https://s20.lgstatic.com/growth/activity/20220609/1654743608150.png') no-repeat center;
        background-size: 59PX 9PX;
        z-index: 9;
    }
    &::after {
        content: '';
        position: absolute;
        right: -79PX;
        top: 13PX;
        width: 59PX;
        height: 9PX;
        background: url('https://s20.lgstatic.com/growth/activity/20220609/1654743626450.png') no-repeat center;
        background-size: 59PX 9PX;
        z-index: 9;
    }
}
.box5-cards {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 48PX;
    .box5-card {
        position: relative;
        width: 353PX;
        height: 150PX;
        background: url('https://s20.lgstatic.com/growth/activity/20220609/1654756759288.png') no-repeat center;
        background-size: 353PX 150PX;
        margin-bottom: 20PX;
        &.more {
            background: url('https://s20.lgstatic.com/growth/activity/20220609/1654757333900.png') no-repeat center;
            background-size: 353PX 150PX;
            .box5-card-title {
                width: 183PX;
            }
        }
        .box5-card-title {
            position: absolute;
            top: 0;
            left: 8PX;
            width: 123PX;
            height: 42PX;
            line-height: 42PX;
            font-size: 20PX;
            text-align: center;
            color: #fff;
        }
        .box5-card-content {
            position: absolute;
            left: 10PX;
            top: 42PX;
            width: 333PX;
            height: 96PX;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding-left: 29PX;
            box-sizing: border-box;
            .box5-card-txt {
                width: 100%;
                font-size: 16PX;
                font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                font-weight: 400;
                color: #585E8B;
                line-height: 24PX;
            }
        }
    }
}
.box5-steps {
    position: relative;
    width: 1151PX;
    height: 188PX;
    background: url('https://s20.lgstatic.com/growth/activity/20220609/1654757757828.png') no-repeat center;
    background-size: 1151PX 188PX;
    margin: 48PX auto 0;
    .box5-step {
        position: absolute;
        top: 0;
        height: 188PX;
        &.step1 {
            left: 57PX;
            width: 266PX;
        }
        &.step2 {
            left: 421PX;
            width: 313PX;
        }
        &.step3 {
            left: 798PX;
            width: 302PX;
        }
        .step-title {
            height: 37PX;
            font-size: 30PX;
            font-family: AppleSystemUIFont;
            color: #FFFFFF;
            line-height: 37PX;
            text-shadow: 0PX 2PX 4PX rgba(36, 40, 233, 0.5);
            opacity: .6;
            margin-top: 38PX;
        }
        .step-txt {
            font-size: 26PX;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 37PX;
            text-shadow: 0PX 2PX 4PX rgba(62, 35, 244, 0.5);
        }
    }
}
.box6-title {
    text-align: center;
    font-size: 40PX;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #414878;
    line-height: 40PX;
    margin-top: 80PX;
}
.box6-sub-title {
    position: relative;
    width: 424PX;
    height: 36PX;
    font-size: 24PX;
    font-family: AppleSystemUIFont;
    color: #414878;
    line-height: 36PX;
    text-align: center;
    margin: 24PX auto 0;
    &2 {
        width: 434PX;
        margin-top: 0;
    }
    &::before {
        content: '';
        position: absolute;
        left: -79PX;
        top: 13PX;
        width: 59PX;
        height: 9PX;
        background: url('https://s20.lgstatic.com/growth/activity/20220609/1654743608150.png') no-repeat center;
        background-size: 59PX 9PX;
        z-index: 9;
    }
    &::after {
        content: '';
        position: absolute;
        right: -79PX;
        top: 13PX;
        width: 59PX;
        height: 9PX;
        background: url('https://s20.lgstatic.com/growth/activity/20220609/1654743626450.png') no-repeat center;
        background-size: 59PX 9PX;
        z-index: 9;
    }
}
.box6-content {
    position: relative;
    width: 716PX;
    height: 644PX;
    background: url('https://s20.lgstatic.com/growth/activity/20220609/1654759240386.png') no-repeat center;
    background-size: 716PX 644PX;
    margin: 69PX auto 0;
    .box6-btn {
        position: absolute;
        top: 0;
        width: 252PX;
        height: 46PX;
        line-height: 46PX;
        font-size: 21PX;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #FFFFFF;
        background: linear-gradient(134deg, #A954FF 0%, #684CFF 100%);
        box-shadow: 0PX 2PX 4PX 0PX rgba(226, 232, 255, 0.5);
        border-radius: 23PX;
        text-align: center;
        &.box6-l-btn {
            left: -170PX;
        }
        &.box6-r-btn {
            right: -170PX;
        }
    }
    .box6-l-content {
        position: absolute;
        top: 135PX;
        left: -204PX;
        display: flex;
        justify-content: space-between;
        width: 418PX;
        flex-wrap: wrap;
        & > img {
            width: 188PX;
            height: 65PX;
            margin-bottom: 32PX;
        }
    }
    .box6-r-content {
        position: absolute;
        top: 152PX;
        right: -270PX;
        display: flex;
        justify-content: space-between;
        width: 477PX;
        flex-wrap: wrap;
        .box6-r-item {
            position: relative;
            width: 477PX;
            height: 96PX;
            background: url('https://s21.lgstatic.com/growth/activity/20220609/1654760490256.png') no-repeat center;
            background-size: 477PX 96PX;
            margin-bottom: 22PX;
            .r-item-title {
                position: absolute;
                top: 18PX;
                left: 30PX;
                height: 27PX;
                font-size: 24PX;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 27PX;
            }
            .left20 {
                left: 20PX;
            }
            .r-item-con {
                position: absolute;
                top: 0;
                left: 0;
                width: 477PX;
                height: 96PX;
                padding-left: 164PX;
                padding-right: 54PX;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .cont-txt {
                    position: relative;
                    font-size: 16PX;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: rgba(88, 94, 139, .7);
                    line-height: 28PX;
                    width: 100%;
                    margin-bottom: 8PX;
                    &::before {
                        content: '';
                        position: absolute;
                        left: -12PX;
                        top: 12PX;
                        width: 4PX;
                        height: 4PX;
                        background-color: #60618B;
                        border-radius: 50%;
                    }
                }
            }
        }
    }
}
.box6-steps {
    position: relative;
    width: 1151PX;
    height: 368PX;
    background: url('https://s20.lgstatic.com/growth/activity/20220609/1654763578209.png') no-repeat center;
    background-size: 1151PX 368PX;
    margin: 48PX auto 0;
    .box6-step {
        position: absolute;
        top: 0;
        height: 188PX;
        &.step1 {
            left: 57PX;
            width: 251PX;
        }
        &.step2 {
            left: 421PX;
            width: 313PX;
        }
        &.step3 {
            left: 798PX;
            width: 302PX;
        }
        &.step4 {
            top: 190PX;
            left: 782PX;
            width: 310PX;
        }
        &.step5 {
            top: 190PX;
            left: 450PX;
            width: 219PX;
        }
        &.step6 {
            top: 190PX;
            left: 78PX;
            width: 261PX;
        }
        .step-title {
            height: 42PX;
            font-size: 30PX;
            font-family: AppleSystemUIFont;
            color: #FFFFFF;
            line-height: 42PX;
            text-shadow: 0PX 2PX 4PX rgba(36, 40, 233, 0.5);
            opacity: .6;
            margin-top: 38PX;
        }
        .step-txt {
            font-size: 24PX;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 30PX;
            text-shadow: 0PX 2PX 4PX rgba(62, 35, 244, 0.5);
        }
    }
}
.box7-sub-title {
    position: relative;
    width: 500PX;
    height: 36PX;
    font-size: 24PX;
    font-family: AppleSystemUIFont;
    color: #414878;
    line-height: 36PX;
    text-align: center;
    margin: 106PX auto 0;
    &2 {
        width: 434PX;
        margin-top: 0;
    }
    &::before {
        content: '';
        position: absolute;
        left: -79PX;
        top: 13PX;
        width: 59PX;
        height: 9PX;
        background: url('https://s20.lgstatic.com/growth/activity/20220609/1654743608150.png') no-repeat center;
        background-size: 59PX 9PX;
        z-index: 9;
    }
    &::after {
        content: '';
        position: absolute;
        right: -79PX;
        top: 13PX;
        width: 59PX;
        height: 9PX;
        background: url('https://s20.lgstatic.com/growth/activity/20220609/1654743626450.png') no-repeat center;
        background-size: 59PX 9PX;
        z-index: 9;
    }
}
.box7-content {
    display: flex;
    width: 1054PX;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 48PX auto 0;
    & > img {
        width: 242PX;
        height: 89PX;
        margin-bottom: 22PX;
    }
}
.box7-btn {
    width: 344PX;
    height: 66PX;
    background: linear-gradient(90deg, #FF5487 0%, #FF854C 100%);
    border-radius: 33PX;
    font-size: 24PX;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 66PX;
    text-align: center;
    margin: 36PX auto 0;
}
.box8-title {
    text-align: center;
    font-size: 40PX;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #fff;
    line-height: 40PX;
    margin-top: 80PX;
}
.box8-sub-title {
    position: relative;
    width: 120PX;
    height: 36PX;
    font-size: 24PX;
    font-family: AppleSystemUIFont;
    color: #fff;
    line-height: 36PX;
    text-align: center;
    margin: 8PX auto 0;
    &2 {
        width: 434PX;
        margin-top: 0;
    }
    &::before {
        content: '';
        position: absolute;
        left: -79PX;
        top: 13PX;
        width: 59PX;
        height: 9PX;
        background: url('https://s21.lgstatic.com/growth/activity/20220610/1654828795175.png') no-repeat center;
        background-size: 59PX 9PX;
        z-index: 9;
    }
    &::after {
        content: '';
        position: absolute;
        right: -79PX;
        top: 13PX;
        width: 59PX;
        height: 9PX;
        background: url('https://s20.lgstatic.com/growth/activity/20220610/1654828766432.png') no-repeat center;
        background-size: 59PX 9PX;
        z-index: 9;
    }
}
.box8-pops {
    display: flex;
    width: 826PX;
    height: 46PX;
    justify-content: space-between;
    margin: 24PX auto 0;
    &2 {
        width: 671PX;
        margin: 30PX auto;
    }
    .box8-pop {
        height: 46PX;
        line-height: 46PX;
        background-color: #fff;
        border-radius: 23PX;
        text-align: center;
        font-size: 21PX;
        color: #9A9BCF;
        padding: 0 24PX;
    }
}
/deep/ .sw1-wrap {
    width: 1200PX;
    height: 320PX;
    margin-top: 60PX;
    .swiper-slide {
        width: 640PX;
        opacity: 0;
        img {
            display: block;
            width: 640PX;
            margin: 0 auto;
        }
        &.swiper-slide-active {
            opacity: 1;
        }
        &.swiper-slide-next, &.swiper-slide-prev {
            opacity: .5;
        }
    }
    .swiper-pagination {
        bottom: 0PX;
    }
    .swiper-pagination-bullet{
        width: 10PX;
        height: 10PX;
        background: linear-gradient(90deg, #fff 0%, #fff 100%);
        border-radius: 50%;
        opacity: .5;
        &-active{
            opacity: 1;
            border-radius: 10PX;
            width: 22PX;
            background: linear-gradient(90deg, #fff 0%, #fff 100%);
        }
    }
    .swiper-button-prev {
        background: url('https://s21.lgstatic.com/growth/activity/20210402/1617354468162.png') no-repeat center;
        background-size: 100% 100%;
        width: 58PX;
        height: 58PX;
        // top: 50%;
        // transform: translateY(-50%);
        // left: 0PX;
    }
    .swiper-button-next {
        background: url('https://s21.lgstatic.com/growth/activity/20210402/1617354439579.png') no-repeat center;
        background-size: 100% 100%;
        width: 58PX;
        height: 58PX;
        // // right: -80PX;
        // // top: 50%;
        // transform: translateY(-50%);
        // right: 0PX;
    }
}
.box9-sub-title {
    position: relative;
    width: 180PX;
    height: 36PX;
    font-size: 24PX;
    font-family: AppleSystemUIFont;
    color: #414878;
    line-height: 36PX;
    margin-top: 12PX;
    text-align: center;
    margin: 57PX auto 0;
    &2 {
        width: 389PX;
        margin-top: 80PX;
    }
    &::before {
        content: '';
        position: absolute;
        left: -79PX;
        top: 13PX;
        width: 59PX;
        height: 9PX;
        background: url('https://s20.lgstatic.com/growth/activity/20220609/1654743608150.png') no-repeat center;
        background-size: 59PX 9PX;
        z-index: 9;
    }
    &::after {
        content: '';
        position: absolute;
        right: -79PX;
        top: 13PX;
        width: 59PX;
        height: 9PX;
        background: url('https://s20.lgstatic.com/growth/activity/20220609/1654743626450.png') no-repeat center;
        background-size: 59PX 9PX;
        z-index: 9;
    }
}
/deep/ .sw2-wrap {
    position: relative;
    width: 1482PX;
    height: 674PX;
    margin: 42PX auto;
    .swiper-slide {
        width: 357PX !important;
        img {
            display: block;
            width: 357PX;
            margin: 0 auto;
        }
    }
    .left-mask {
        position: absolute;
        left: 0;
        top: 0;
        width: 166px;
        height: 674px;
        background: linear-gradient(270deg, rgba(242, 242, 250, 0) 0%, #F2F2FA 100%);
        z-index: 9;
    }
    .right-mask {
        position: absolute;
        right: 0;
        top: 0;
        width: 166px;
        height: 674px;
        background: linear-gradient(270deg, #F2F2FA 0%,  rgba(242, 242, 250, 0) 100%);
        z-index: 9;
    }
}
.box10-title {
    position: relative;
    width: 440PX;
    height: 36PX;
    line-height: 36PX;
    font-size: 36PX;
    font-weight: 600;
    color: #fff;
    text-align: center;
    margin: 70PX auto 0;
    &::after {
        content: "名企入驻";
        position: absolute;
        right: -120PX;
        width: 107PX;
        height: 35PX;
        line-height: 35PX;
        background: linear-gradient(140deg, #FFEFE7 0%, #FFDBCB 100%);
        border-radius: 4PX;
        font-size: 20PX;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #724DFF;
    }
}
.box10-labels {
    display: flex;
    justify-content: space-between;
    margin-top: 48PX;
    align-items: center;
    .babel-line {
        display: flex;
        font-size: 23PX;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        line-height: 52PX;
        color: #FFFFFF;
        &.label-1 {
            & > img {
                width: 66PX;
                height: 37PX;
            }
        }
        &.label-2 {
            & > img {
                width: 87PX;
                height: 37PX;
            }
        }
        &.label-3 {
            & > img {
                width: 139PX;
                height: 37PX;
            }
        }
    }
    .label-tips {
        height: 24PX;
        font-size: 17PX;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 24PX;
    }
}
.box10-tips {
    height: 22PX;
    font-size: 16PX;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 22PX;
    text-align: center;
    margin-top: 30PX;
}
.footer {
    position: fixed;
    background-color:transparent;
    border: none;
    bottom: 0PX;
    left: 50%;
    transform: translate(-50%);
    z-index: 999;
    width: 100%;
    height: 138PX;
    box-shadow: 0PX -12PX 12PX 0PX rgba(156, 157, 185, 0.22);
    background-color: #fff;
    .img {
        width: 1920PX;
        height: 138PX;
        display: block;
        margin: 0 auto;
    }
    .iconBox {
        position: absolute;
        top: -30PX;
        left: 50%;
        transform: translate(-50%);
        z-index: 9999;
        width: 940PX;
        .icon {
            float: right;
            width: 134PX;
        }
    }
}
.box10-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .box10-left {
        display: flex;
        align-items: center;
        color: #A954FF;
        font-size: 26PX;
        & > img {
            width: 24PX;
            height: 24PX;
            margin-right: 12PX;
        }
    }
    .box10-right {
        width: 384PX;
        height: 68PX;
        line-height: 68PX;
        background: linear-gradient(90deg, #FF5487 0%, #FF854C 100%);
        border-radius: 39PX;
        font-size: 24PX;
        color: #fff;
        text-align: center;
    }
}
</style>
